import { TransitionKind } from "@repo/api/transition";
import { msToFrames } from "../../utils/timing.ts";
import { CompositionTransitionBuilder } from "./CompositionTransitionBuilder.ts";

const transitionKind = TransitionKind.enum.NONE;

export const CompositionNoneTransitionBuilder: CompositionTransitionBuilder = {
  formConfig: {
    kind: transitionKind,
    buildDefaultValue: () => ({ kind: transitionKind }),
  },

  getPreviewClipDurationInFrames: (props) => msToFrames(2000, props.fps),
};
